export { getLocaleData, getLocalizedDateFormat, getDatePlaceholder } from './Locale';